import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const NewAddonIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();
  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.NEW_ADDON}/${ROUTE_KEYS.NEW_ADDON_DETAILS}`, {
      replace: true
    });
  }, []);

  return <div />;
};

export default NewAddonIndex;
